module.exports = __webpack_public_path__ + "static/media/3동물권-돼지이야기.1b47ca8b.mp3";